<template>
  <ClientOnly>
    <DmModal
      v-model="modals.details"
      title=""
    >
      <div
        v-if="service"
        class="garage-price-list-element-modal__wrapper"
      >
        <div class="garage-price-list-element-modal__name">
          {{ capitalizeFirstLetter(service.name) }}
        </div>
        <div class="garage-price-list-element-modal__section garage-price-list-element-modal__section--border">
          <div v-if="service.description">
            {{ modalDescription }}
            <u
              v-show="service.description.length > shortDescriptionModalLength"
              @click="expanded = !expanded"
              role="button"
            >{{ expanded ? 'Zwiń' : 'Rozwiń' }}
            </u>
          </div>
        </div>
        <div
          class="garage-price-list-element-modal__section garage-price-list-element-modal__section--border garage-price-list-element-modal__section--row"
        >
          <div class="garage-price-list-element-modal__section-label">
            Cena:
          </div>
          <div
            class="garage-price-list-element-modal__section-value garage-price-list-element-modal__section-value--price"
          >
            <div v-if="service.price?.priceFrom === service.price?.priceTo">
              {{ service.price?.priceFrom || 0 }} zł
            </div>
            <div v-else-if="service.price?.priceFrom && service.price.priceTo">
              od {{ service.price.priceFrom || 0 }} do {{ service.price.priceTo || 0 }} zł
            </div>
            <div v-else>
              od {{ service.price?.priceFrom || 0 }} zł
            </div>
          </div>
        </div>
        <div
          v-if="service.surcharges?.length"
          class="garage-price-list-element-modal__section garage-price-list-element-modal__section--border"
        >
          <div class="garage-price-list-element-modal__section-label">
            Dopłaty:
          </div>
          <div class="garage-price-list-element-modal__section-values">
            <div
              v-for="surcharge in service.surcharges"
              class="garage-price-list-element-modal__section-value"
            >
              <div class="garage-price-list-element-modal__section-value-left-side">
                {{ surcharge.name }}
              </div>
              <div>
                <div v-if="service.price?.priceFrom === service.price?.priceTo">
                  {{ surcharge.price?.priceFrom || 0 }} zł
                </div>
                <div v-else-if="service.price?.priceFrom && service.price.priceTo">
                  od {{ surcharge.price?.priceFrom || 0 }} do {{ surcharge.price?.priceTo || 0 }} zł
                </div>
                <div v-else>
                  od {{ surcharge.price?.priceFrom || 0 }} zł
                </div>
              </div>
            </div>
          </div>
        </div>

        <NuxtLink
          v-if="premium && onlineBooking"
          :to="nuxtLinkTo(service)"
        >
          <DmButton
            class="garage-price-list-element-modal__button"
            title="Wybierz termin"
          />
        </NuxtLink>
      </div>
    </DmModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import { DmButton, DmModal } from '@dobrymechanik/vue-ui-v2';
import type { PriceElementView } from '~/api/docs/app';
import { capitalizeFirstLetter } from '~/helpers/helpers';

interface IProps {
  service: PriceElementView | null;
  modals: {
    details: boolean;
  };
  premium?: boolean;
  onlineBooking?: boolean;
}

// data
const shortDescriptionModalLength: number = 64;
const expanded: Ref<boolean> = ref(false);

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();

// computed
const modalDescription = computed(() => {
  return !expanded.value && props.service?.description?.length || 0 > shortDescriptionModalLength
    ? props.service?.description?.substring(0, shortDescriptionModalLength) + '...'
    : props.service?.description;
});

// methods
const nuxtLinkTo = (service: PriceElementView) => {
  if (service.flags?.virtual) {
    return route.path.includes('/services') ? `${route.path}?other-reason=true` : `${route.path}/services?other-reason=true`;
  }

  return route.meta.layout === 'modal'
    ? `${route.path}/${service.autobooking?.serviceId}?repairDescription=${service.name}`
    : `${route.path}/services/${service.autobooking?.serviceId}?repairDescription=${service.name}`;
};
</script>

<style lang="scss">
@import url('assets/styles/components/garage-price-element.scss');
</style>